declare namespace $ {

	type $mol_button_minor__title_shm_hitalama_guide_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__sub_shm_hitalama_guide_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_guide_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['editable'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_guide_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['add_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_check_icon__hint_shm_hitalama_guide_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_shm_hitalama_guide_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['repository_opened'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_guide_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['Repository_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $shm_hitalama_guide_item__catalog_shm_hitalama_guide_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['catalog'] >
		,
		ReturnType< $shm_hitalama_guide_item['catalog'] >
	>
	type $shm_hitalama_guide_item__id_shm_hitalama_guide_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['identity'] >
		,
		ReturnType< $shm_hitalama_guide_item['id'] >
	>
	type $shm_hitalama_guide_item__current_shm_hitalama_guide_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['page_current'] >
		,
		ReturnType< $shm_hitalama_guide_item['current'] >
	>
	type $shm_hitalama_guide_item__toggle_shm_hitalama_guide_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['group_toggle'] >
		,
		ReturnType< $shm_hitalama_guide_item['toggle'] >
	>
	type $shm_hitalama_guide_drag__catalog_shm_hitalama_guide_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['catalog'] >
		,
		ReturnType< $shm_hitalama_guide_drag['catalog'] >
	>
	type $shm_hitalama_guide_drag__locked_shm_hitalama_guide_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['drag_locked'] >
		,
		ReturnType< $shm_hitalama_guide_drag['locked'] >
	>
	type $shm_hitalama_guide_drag__roots_shm_hitalama_guide_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['roots'] >
		,
		ReturnType< $shm_hitalama_guide_drag['roots'] >
	>
	type $shm_hitalama_guide_drag__children_shm_hitalama_guide_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['children'] >
		,
		ReturnType< $shm_hitalama_guide_drag['children'] >
	>
	type $shm_hitalama_guide_drag__expanded_shm_hitalama_guide_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['expanded'] >
		,
		ReturnType< $shm_hitalama_guide_drag['expanded'] >
	>
	type $shm_hitalama_guide_drag__Item_shm_hitalama_guide_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['Item'] >
		,
		ReturnType< $shm_hitalama_guide_drag['Item'] >
	>
	type $mol_select__value_shm_hitalama_guide_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['new_kind'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_guide_19 = $mol_type_enforce<
		({ 
			'page': string,
			'group': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_string__hint_shm_hitalama_guide_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_guide_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['new_id'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_hitalama_guide_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_guide_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['new_title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_guide_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['folder_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_guide_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['new_parent'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_button_major__title_shm_hitalama_guide_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_guide_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_textarea__enabled_shm_hitalama_guide_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['editable'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__value_shm_hitalama_guide_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['sections_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_labeler__title_shm_hitalama_guide_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_guide_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['Sections_input'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_button_minor__title_shm_hitalama_guide_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_guide_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['editable'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_guide_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['save_sections'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_list_page__title_shm_hitalama_guide_35 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_list_page['title'] >
	>
	type $shm_list_page__filter_shm_hitalama_guide_36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['query'] >
		,
		ReturnType< $shm_list_page['filter'] >
	>
	type $shm_list_page__add_content_shm_hitalama_guide_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_page['add_content'] >
	>
	type $shm_list_page__body_shm_hitalama_guide_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_page['body'] >
	>
	type $mol_list__sub_shm_hitalama_guide_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $shm_hitalama_guide_panel__param_shm_hitalama_guide_40 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_panel['param'] >
	>
	type $shm_hitalama_guide_panel__section_shm_hitalama_guide_41 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_panel['section'] >
	>
	type $shm_hitalama_guide_repository__catalog_shm_hitalama_guide_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['catalog'] >
		,
		ReturnType< $shm_hitalama_guide_repository['catalog'] >
	>
	type $shm_hitalama_guide_repository__opened_shm_hitalama_guide_43 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide['repository_opened'] >
		,
		ReturnType< $shm_hitalama_guide_repository['opened'] >
	>
	type $shm_hitalama_guide_repository__body_shm_hitalama_guide_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_guide_repository['body'] >
	>
	export class $shm_hitalama_guide extends $mol_book2 {
		guide_pages( ): readonly($mol_view)[]
		query( next?: string ): string
		Add_icon( ): $mol_icon_plus
		editable( ): boolean
		add_toggle( next?: any ): any
		Add( ): $mol_button_minor
		repository_opened( next?: boolean ): boolean
		Repository_icon( ): $mol_icon_cog
		Repository_toggle( ): $mol_check_icon
		create_content( ): readonly($mol_view)[]
		catalog( ): $shm_hitalama_guide_catalog
		drag_locked( ): boolean
		roots( ): readonly(string)[]
		children( id: any): readonly(string)[]
		expanded( id: any, next?: boolean ): boolean
		identity( id: any): string
		page_current( id: any): boolean
		group_toggle( id: any, next?: any ): any
		Item( id: any): $shm_hitalama_guide_item
		Names( ): $shm_hitalama_guide_drag
		new_kind( next?: string ): string
		New_kind( ): $mol_select
		new_id( next?: string ): string
		New_id( ): $mol_string
		new_title( next?: string ): string
		New_title( ): $mol_string
		folder_options( ): Record<string, any>
		new_parent( next?: string ): string
		New_parent( ): $mol_select
		add( next?: any ): any
		Create_button( ): $mol_button_major
		sections_text( next?: string ): string
		Sections_input( ): $mol_textarea
		Sections( ): $mol_labeler
		save_sections( next?: any ): any
		Save_sections( ): $mol_button_minor
		menu_title( ): string
		pages( ): ReturnType< $shm_hitalama_guide['guide_pages'] >
		List( ): $shm_list_page
		Create( ): $mol_list
		create_opened( next?: boolean ): boolean
		Panel( ): $shm_hitalama_guide_panel
		Repository( ): $shm_hitalama_guide_repository
	}
	
}

//# sourceMappingURL=guide.view.tree.d.ts.map